import { render, staticRenderFns } from "./topContent.vue?vue&type=template&id=d1b1034c&scoped=true&"
import script from "./topContent.vue?vue&type=script&lang=js&"
export * from "./topContent.vue?vue&type=script&lang=js&"
import style0 from "./topContent.vue?vue&type=style&index=0&id=d1b1034c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b1034c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Top: require('/app/components/topContent/top.vue').default,ALink: require('/app/components/aLink.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
